<template>
  <div>
    <div class="breadcrumb-area pos-relative w-100">
      <h1>Danh sách bước chuyển ticket</h1>
      <div class="btn-group float-right">
        <DraggableTable
          :naming="$router.name"
          v-model="fieldsTable"
          @change="filterTable = $event"
        />
        <button
          class="font-medium f12 btn btn-outline-secondary"
          v-if="canCreateAndEdit('CNPS_TICKET_TRANSITION_UPDATE')"
          @click="create"
        >
          <i class="bx bx-plus-circle"></i><span>&nbsp;</span>Thêm mới
        </button>
      </div>
    </div>
    <div class="card p-10 pt-15 b-t-1-869fb229">
      <div class="card-header m-b-10">
        <form class="box-search" @submit.prevent="submitForm">
          <div class="form-group">
            <input
              type="text"
              v-model.trim="search.key"
              data-toggle="tooltip"
              data-placement="top"
              title="Từ khoá"
              class="form-control f12 hc-37 text-search"
              placeholder="Từ khoá"
            />
          </div>
          <div class="form-group">
            <Select2
              v-model="search.category"
              @change="fetchDataCurrentState()"
              :options="Config.getSearch(dataCategoryTypeCode)"
              placeholder="Mã danh mục"
            />
          </div>
          <div class="form-group">
            <Select2
              v-model="search.isFromAll"
              :options="Config.getSearch(optionIsFromAll)"
              placeholder="Từ tất cả hiện trạng?"
            />
          </div>
          <div class="form-group">
            <Select2
              v-model="search.isFromNull"
              :options="Config.getSearch(optionIsFromNull)"
              placeholder="Từ hiện trạng NULL?"
            />
          </div>
          <div class="form-group">
            <Select2
              v-model="search.fromState"
              :options="Config.getSearch(dataCurrentState)"
              placeholder="Hiện trạng đầu vào"
            />
          </div>
          <div class="form-group">
            <Select2
              v-model="search.toState"
              :options="Config.getSearch(dataCurrentState)"
              placeholder="Hiện trạng đầu ra"
            />
          </div>
          <div class="form-group">
            <Select2
              v-model="search.transitionCondition"
              :options="Config.getSearch(optionTransitionCondition)"
              placeholder="Điều kiện chuyển"
            />
          </div>
          <div class="form-group">
            <Select2
              v-model="search.postFunction"
              :options="Config.getSearch(optionPostFunction)"
              placeholder="Lệnh tự động"
            />
          </div>

          <div class="form-group form-group-action">
            <button type="button" class="btn btn-primary hc-37 mr-2 pt-2" @click="submitForm">
              <i class="bx bx-filter-alt"></i><span>&nbsp;</span>Lọc
            </button>
            <button type="button" class="btn btn-outline-light hc-37 mr-2 pt-2" @click="removeForm">
              <i class="bx bx-filter-alt"></i><span>&nbsp;</span>Bỏ lọc
            </button>
          </div>
        </form>
      </div>
      <div class="card-body">
        <div class="tab-content" id="nav-tabContent">
          <div class="p-10">
            <b-table
              :busy.sync="tbLoading"
              sticky-header
              responsive
              hover
              :items="lists"
              :fields="filterTable"
              :fixed="true"
              :bordered="true"
            >
              <template #table-busy>
                <div class="text-center my-2">
                  <b-spinner class="align-middle"></b-spinner>
                </div>
              </template>
              <template #cell(name)="data">
                <p>{{ data.item.name ? data.item.name : '' }}</p>
              </template>
              <template #cell(category)="data">
                <p>
                  {{
                    data.item.category
                      ? joinArrayData(data.item.category, dataCategoryTypeCode)
                      : ''
                  }}
                </p>
              </template>
              <template #cell(fromState)="data">
                <p v-if="data.item.isFromAll === true">Từ tất cả hiện trạng</p>
                <p v-if="data.item.isFromNull === true">Từ hiện trạng NULL</p>
                <p>
                  {{
                    data.item.fromState ? joinArrayData(data.item.fromState, dataCurrentState) : ''
                  }}
                </p>
              </template>
              <template #cell(toState)="data">
                <p>
                  {{ data.item.toState ? joinArrayData(data.item.toState, dataCurrentState) : '' }}
                </p>
              </template>
              <template #cell(note)="data">
                <p>{{ data.item.note ? data.item.note : '' }}</p>
              </template>
              <template #cell(transitionCondition)="data">
                <p>
                  {{
                    data.item.transitionCondition
                      ? joinArrayData(data.item.transitionCondition, optionTransitionCondition)
                      : ''
                  }}
                </p>
              </template>
              <template #cell(postFunction)="data">
                <p>
                  {{
                    data.item.postFunction
                      ? joinArrayData(data.item.postFunction, optionPostFunction)
                      : ''
                  }}
                </p>
              </template>

              <template #cell(action)="data">
                <b-dropdown class="text-center" variant="outline-light">
                  <b-dropdown-item
                    class="dropdown-item"
                    v-if="canCreateAndEdit('CNPS_TICKET_TRANSITION_UPDATE')"
                    @click="edit(data.item.id)"
                    ><span>&nbsp;</span>Sửa
                  </b-dropdown-item>
                </b-dropdown>
              </template>
            </b-table>
          </div>
        </div>
        <div class="pagination-bottom">
          <b-pagination
            @change="onPageChange"
            :total-rows="pagination.total"
            :per-page="search.pageSize"
            class="fl-right mr-2"
          ></b-pagination>
        </div>
      </div>
    </div>
    <VueLoadingOverlay :active.sync="showLoading" :is-full-page="true"> </VueLoadingOverlay>
  </div>
</template>
<script>
  import { mapGetters } from 'vuex'
  import Config from '@/thirdParty/config'
  import { TicketService } from '@/services/ticket.service'
  import cloneDeep from 'lodash/cloneDeep'
  import mxItemAction from '../mx-item-action.js'

  const fieldsTable = [
    { key: 'name', label: 'Tên', thStyle: 'min-width: 150px' },
    { key: 'category', label: 'Mã danh mục', thStyle: 'min-width: 150px' },
    { key: 'fromState', label: 'Hiện trạng đầu vào', thStyle: 'min-width: 150px' },
    { key: 'toState', label: 'Hiện trạng đầu ra', thStyle: 'min-width: 150px' },
    { key: 'note', label: 'Mô tả', thStyle: 'min-width: 150px' },
    { key: 'transitionCondition', label: 'Điều kiện chuyển', thStyle: 'min-width: 150px' },
    {
      key: 'postFunction',
      label: 'Lệnh tự động',
      class: 'text-center',
      thStyle: 'min-width: 150px',
    },
    { key: 'action', label: 'Thao tác', fixIndex: 999, class: 'text-center' },
  ]

  export default {
    mixins: [mxItemAction],
    data() {
      return {
        fieldsTable,
        filterTable: fieldsTable,
        search: {
          pageSize: 20,
          pageIndex: 1,
        },
        pagination: {
          total: 0,
        },
        showLoading: false,
        tbLoading: false,
        lists: [],
        dataCategoryTypeCode: [],
        optionIsFromAll: [
          { id: true, text: 'Có' },
          { id: false, text: 'Không' },
        ],
        optionIsFromNull: [
          { id: true, text: 'Có' },
          { id: false, text: 'Không' },
        ],
        optionTransitionCondition: [
          { id: 'FIELD_ASSIGNEE', text: 'assignee' },
          { id: 'FIELD_SUPERVISOR', text: 'supervisor' },
          { id: 'ROLE_AFS_LEADER', text: 'Aftersale leader' },
        ],
        optionPostFunction: [
          { id: 'MOVE_COMPLETE_SUCCESS', text: 'MOVE_COMPLETE_SUCCESS' },
          { id: 'MOVE_COMPLETE_FAIL', text: 'MOVE_COMPLETE_FAIL' },
          { id: 'MOVE_COMPLETE_OTHER', text: 'MOVE_COMPLETE_OTHER' },
          { id: 'MOVE_CANCEL_SUCCESS', text: 'MOVE_CANCEL_SUCCESS' },
          { id: 'MOVE_CANCEL_FAIL', text: 'MOVE_CANCEL_FAIL' },
          { id: 'MOVE_CANCEL_OTHER', text: 'MOVE_CANCEL_OTHER' },
        ],
        dataCurrentState: [],
      }
    },
    created() {
      TicketService.fetchCategory()
        .then(s => s.data?.map(s => ({ id: s.code, text: s.name })) ?? [])
        .then(s => (this.dataCategoryTypeCode = s))
      this.fetchData()
      this.fetchDataCurrentState()
    },
    computed: {
      joinArrayData() {
        return (item, options) => {
          const mapData = options.find(e => e.id === item)
          return mapData ? mapData.text : ''
        }
      },
    },
    methods: {
      async submitForm() {
        this.search.pageIndex = 1
        this.fetchData()
      },
      async removeForm() {
        this.search = {
          pageSize: 20,
          pageIndex: 1,
        }
        await this.fetchData()
        await this.fetchDataCurrentState()
      },
      preareData() {
        const data = cloneDeep(this.search)
        for (const key in data) {
          if (data[key] === '0') delete data[key]
        }
        return data
      },
      async fetchData() {
        try {
          this.tbLoading = true
          const params = this.preareData()
          const response = await TicketService.fetchTransitionTicket(params)
          if (response.code === 1000) {
            this.lists = response.data
            this.pagination.total = response.meta.total
          } else {
            this.showFailMx(response.message)
          }
        } catch (error) {
          this.showFailMx(error.message ?? error)
        } finally {
          this.tbLoading = false
        }
      },
      create() {
        this.$router.push({ path: `/ticket-transition/create` })
      },
      async fetchDataCurrentState() {
        try {
          this.showLoading = true
          let params = {}
          if (this.search.category) {
            params = { applyFor: [this.search.category] }
          }
          const response = await TicketService.fetchCurrentStateTicket(params)
          if (response.code === 1000) {
            this.dataCurrentState = response.data.map(s => ({ id: s.code, text: s.name })) ?? []
          } else {
            this.showFailMx(response.message)
          }
        } catch (error) {
          this.showFailMx(error.message ?? error)
        } finally {
          this.showLoading = false
          this.selectedTicket = []
        }
      },
      edit(id) {
        this.$router.push({ path: `/ticket-transition/${id}` })
      },
      onPageChange(page) {
        this.search.pageIndex = page
        this.fetchData()
      },
    },
  }
</script>
<style scoped></style>
